import moment from 'moment';

/**
 * @description
 * Check if the slot is in the past
 */
export function isSlotPassed(event, slot) {
  return moment(slot.start) >= moment(event.keyDates.jobfair.beginAt) && moment(slot.start) < moment();
}
